/* eslint-disable react/react-in-jsx-scope */
import { DatePicker, Space, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styles from './index.less';
/**
 * 周选择器
 * @param {*} props
 */
const WeekPicker = (props, ref) => {
  useImperativeHandle(
    ref,
    () => {
      return {
        backToToday: () => {
          setcurrent(moment());
        },
      };
    },
    // [input],
  );
  const { onChange = () => {} } = props;
  const [current, setcurrent] = useState(() => moment());
  const changeLocal = (...params) => {
    console.log('change le');
    const [now] = params;
    setcurrent(now);
    onChange(...params);
  };
  //  上一个
  const lastOne = (params) => {
    const cache = moment(current).subtract(7, 'days');
    setcurrent(cache);
  };
  // 下一个
  const nextOne = (params) => {
    const cache = moment(current).add(7, 'days');
    setcurrent(cache);
  };
  useEffect(() => {
    onChange(current);
  }, [current]);

  return (
    <Space>
      <Button type="text" onClick={lastOne}>
        <LeftOutlined />
      </Button>
      <DatePicker
        className={styles.wrap}
        suffixIcon={null}
        size="large"
        value={current}
        picker={'week'}
        onChange={changeLocal}
        allowClear={false}
        bordered={false}
        format={(momentLocal) => {
          // console.log(momentLocal);
          const day1timeStr = momentLocal
            .isoWeekday(1)
            .format('YYYY[年]MM[月]DD[日]');
          const day7timeStr = momentLocal
            .isoWeekday(7)
            .format('YYYY[年]MM[月]DD[日]');
          return `${day1timeStr}~${day7timeStr}`;
        }}
      />
      <Button type="text" onClick={nextOne}>
        <RightOutlined />
      </Button>
    </Space>
  );
};

export default forwardRef(WeekPicker);
